<template>
    <div class="login-page">
        <div v-if="showBack" style="text-align: left;width: 100%;position: absolute;top: 40px;padding-left: 20px;">
            <van-icon name="arrow-left" size="25" @click="back"/>
        </div>

        <div style="width: 100%;text-align: left;box-sizing: border-box;padding: 120px 25px 0;">
            <div style="display: flex;align-items: center">
                <img @click="click5num" :src="gameIconUrl" style="width: 65px;height: 65px;border-radius: 8px;">
                <div style="display: flex;flex-direction: column;margin-left: 15px;">
                    <span style="font-size: 20px;font-weight: bold;">{{ gameName }}</span>
                </div>
            </div>
            <div style="font-size: 16px;color: #666666; text-align: left;margin-top: 8px;">
                <span>欢迎登录</span>
            </div>
        </div>

        <div class="main-border">

            <van-form @submit="onSubmit" ref="submitForm">

                <span class="ds-label" style="margin-top: 20px;">账号</span>
                <van-field label-width="0" label="" style="color: #F18F25" :placeholder="`请输入${ this.webName }账号`"
                           class="border-input" v-model="account" clearable>
                    <template #button>
                        <van-icon name="arrow-down" @click="selectOtherAccount"/>
                    </template>
                </van-field>

                <span class="ds-label" style="margin-top: 20px;">密码</span>
                <van-field label-width="0" type="password" label="" style="color: #F18F25;"
                           placeholder="请输入登录密码" class="border-input" v-model="password" clearable/>

                <van-popup v-model="showPicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="accountColumns"
                            @cancel="showPicker = false"
                            @confirm="pickAccount"
                            @change="onChange"
                    />
                </van-popup>

                <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;font-size: 14px;padding: 0 5px;">

                    <van-checkbox v-model="rememberPassword" icon-size="14px" shape="square" checked-color="#f16868">
                        <span style="color: #666666;">记住密码</span>
                    </van-checkbox>

                    <span @click="toForgetPage" style="color: #f16868;cursor: pointer;">忘记密码?</span>
                </div>

                <div class="box-button">
                    <van-button type="info" block round native-type="submit" :loading="loading" style="height: 40px;margin-top: 30px;font-size: 14px;"
                                loading-text="登录中"
                                color="#f16868">
                        登 录
                    </van-button>
                    <div class="read-div">
                        <van-checkbox v-model="isRead" icon-size="12px" shape="square" checked-color="#f16868">
                            <p class="read-line">我已阅读并同意<span @click="showUrlDialog(1)" class="text-button">《用户协议》</span>
                                和<span @click="showUrlDialog(2)" class="text-button">《隐私政策》</span></p>
                        </van-checkbox>
                    </div>
                    <div class="no-account-tips">还没有账号？<span @click="toRegisterPage" style="color: #f16868;cursor: pointer;">立即注册</span>
                    </div>
                </div>

                <div style="position: absolute;bottom: 20px;left: 0; width: 100%;display: flex;justify-content: center;box-sizing: border-box" v-if="showSpeedCheckbox">
                    <van-checkbox v-model="openSpeed" shape="square" icon-size="14px" checked-color="#f16868" >
                        <span style="color: #888888;font-size: 13px;">我要加速</span>
                    </van-checkbox>
                </div>

            </van-form>

            <van-dialog  class="main-dialog" v-model="readDialogShow" >
                <div style="width: 100%;height: 100%; overflow: hidden;">
                    <div style="width: calc(100% + 13px);height: 100%;">
                        <iframe v-show="true" class="iframe-box" :src="readUrl" frameborder="0"
                                width="100%" height="100%" style="min-height: 320px;overflow-y: hidden;"></iframe>
                    </div>
                </div>
            </van-dialog>

        </div>
    </div>
</template>

<script>

    import {login, get} from '@/api/request'
    import crypto from '@/utils/crypto.js';
    import EventBus from "@/api/EventBus"
    import webConfig from "@/api/config"

    import {Toast} from 'vant'
    import notice from "@/api/notice";

    export default {
        name: 'login',
        data() {
            return {
                account: '',
                password: '',
                rememberPassword: false,
                accountPattern: /^[a-zA-Z0-9_#]{4,30}$/,
                passwordPattern: /^[a-zA-Z0-9~!@#$%^&*()_+.]{6,20}$/,
                loading: false,
                channelId: '',
                gameId: '',
                accountColumns: [],
                showPicker: false,
                userList: [],
                currentIndex: 0,
                showBack: false,
                from: '',
                openSpeed: false,
                showSpeedCheckbox: false,
                webName: '',
                logoUrl: require("@/assets/logo-skeleton.png"),
                clickNum: 0,
                lastClickTime: 0,
                readDialogShow: false,
                readUrl: '',
                isRead: false,
                gameIconUrl: '',
                gameName: '',
            };
        },
        mounted() {
            this.initPage();
            this.getGameInfo();
        },
        methods: {
            click5num() {
                /*if (this.clickNum > 5) {
                    return;
                }
                let now = new Date().getTime();
                if (this.lastClickTime === 0) {
                    this.lastClickTime = now;
                    this.clickNum = 1;
                    return;
                }

                if (now - this.lastClickTime <= 1000) {
                    this.clickNum ++;
                    if (this.clickNum === 5) {
                        this.runTestFun();
                    }
                    else {
                        this.lastClickTime = now;
                    }
                }
                else {
                    this.lastClickTime = now;
                    this.clickNum = 1;
                }*/
            },
            runTestFun() {
                notice.openUrl('');
                Toast('测试功能完成');
            },
            showUrlDialog(n) {
                this.readUrl = n === 1 ? webConfig.agreement : webConfig.privacy;
                this.readDialogShow = true;
            },
            initPage(){
                this.channelId = localStorage.getItem('channelId');
                this.gameId = localStorage.getItem('gameId');

                this.webName = webConfig.appName;
                this.logoUrl = webConfig.logoUrl;

                let isRemember = localStorage.getItem('rememberPassword');
                if (isRemember === "true") {
                    this.rememberPassword = true;
                    this.account = localStorage.getItem('username');
                    this.password = crypto.decrypt(localStorage.getItem('password'));
                }

                this.isRead = localStorage.getItem('isAgreement') === '1';

                //let from = localStorage.getItem('from');

                this.userList = JSON.parse(localStorage.getItem('userList')) || [];
                if (this.userList.length > 0) {
                    this.userList.forEach((v, i) => {
                        this.accountColumns.push(v.u);
                    })
                }
            },
            getGameInfo() {
                let url = "/h5/getGameSimple?gameId=" + this.gameId
                get(url).then(res => {
                    if (res.data.success) {
                        this.gameIconUrl = res.data.data.img_url;
                        this.gameName = res.data.data.game_name;
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            back() {
                this.$router.back();
            },
            onSubmit() {
                let ok = this.checkForm();
                if (ok !== 'ok') {
                    Toast(ok);
                    return;
                }
                if (this.openSpeed) {
                    localStorage.setItem('from', 'web_speedOn');
                }
                this.loading = true;
                let selectSpeed = this.openSpeed ? "1" : "0";
                let params = {
                    channelId: this.channelId,
                    gameId: this.gameId,
                    userName: this.account,
                    password: crypto.encrypt(this.password),
                    selectSpeed: selectSpeed
                };
                login(params).then(res => {
                    this.loading = false;
                    if (res.data.success) {
                        localStorage.setItem('token', res.data.data.token);
                        localStorage.setItem('user', JSON.stringify(res.data.data));
                        localStorage.setItem('loginUrl', res.data.data.loginUrl || '');

                        localStorage.setItem('isAgreement', this.isRead ? '1' : '0');

                        this.handlerRememberPassword();
                        Toast('登录成功');
                        //this.$router.replace({ path: `/play/${this.channelId}/${this.gameId}`});
                        //this.$router.push('/index');
                        this.$parent.enterGame();
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            checkForm() {
                let ok = 'ok';
                if (!this.account) {
                    ok = "请输入"+ this.webName +"账号"
                } else if (!this.password) {
                    ok = "请输入密码";
                } else if (!this.accountPattern.test(this.account)) {
                    ok = this.webName + "账号为4-30位数字或字母";
                } else if (!this.passwordPattern.test(this.password)) {
                    ok = "密码为6-20位数字字母特殊符号";
                } else if (!this.isRead) {
                    ok = '登录需要同意用户协议和隐私政策';
                }
                return ok;
            },
            selectOtherAccount() {
                if (this.accountColumns.length > 0) {
                    this.showPicker = true;
                } else {
                    Toast('当前没有其他账号');
                }

            },
            pickAccount() {
                this.showPicker = false;
                let user = this.userList[this.currentIndex];
                this.account = user.u;
                this.password = crypto.decrypt(user.p);
            },
            onChange(picker, value, index) {
                this.currentIndex = index;
            },
            toForgetPage() {
                this.$router.push({path: '/reset'});
            },
            toRegisterPage() {
                this.$router.push({path: '/register'});
            },
            handlerRememberPassword() {
                localStorage.setItem('rememberPassword', this.rememberPassword);

                this.userList = JSON.parse(localStorage.getItem('userList')) || [];
                let has = false;
                let index = -1;
                this.userList.forEach((v, i) => {
                    if (v.u === this.account) {
                        has = true;
                        index = i;
                    }
                })

                let password = crypto.encrypt(this.password);
                localStorage.setItem('username', this.account);
                localStorage.setItem('password', password);

                if (this.rememberPassword) {
                    if (!has) {
                        let item = {
                            u: this.account,
                            p: password,
                        }
                        this.userList.push(item);
                        localStorage.setItem('userList', JSON.stringify(this.userList));
                    }
                } else {
                    if (has) {
                        this.userList.splice(index, 1);
                        localStorage.setItem('userList', JSON.stringify(this.userList));
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .login-page {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        height: 100vh;
        overflow: hidden;
        background-image: url(../assets/login-background.png);
        background-repeat: no-repeat;
        background-size: 100% auto;
    }

    .main-border {
        max-width: 500px;
        text-align: center;
        background-color: white;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        width: 100%;
        height: 100%;
        border: 1px solid #eceaea;
        padding: 20px 30px;
        box-sizing: border-box;
        margin-top: 30px;
    }

    .select-other {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        color: #b3b3b6;
    }

    .width-line {
        height: 1px;
        margin: 0 1.04rem;
        border-bottom: 1px solid #b3b3b6;
    }

    .forget-row {
        margin-top: 1.5rem;
        font-size: .8rem;
    }

    .box-button {
        margin: 20px 3px 0;

    }

    .ds-label {
        display: inline-block;
        width: 100%;
        text-align: left;
        margin: 5px 4px 0;
        font-size: 15px;
    }

    .read-div{
        display: flex;
        font-size: 12px;
    }
    .text-button{
        color: #f16868;
    }

    .no-account-tips {
        font-size: 14px;
        margin-top: 20px;
        color: #888888;
        text-align: center;
    }

    .van-cell{
        padding: 8px 4px;
    }
    .van-field {
        border-bottom: 1px solid #dddddd;
    }

</style>
